/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetBrewingRecipesSettingsResponse } from '../models/GetBrewingRecipesSettingsResponse';
import type { SaveBrewingRecipesNotificationRequest } from '../models/SaveBrewingRecipesNotificationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BrewingRecipesSettingsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Brewing Recipes settings
   * Gets the user's Brewing Recipes settings
   * @returns GetBrewingRecipesSettingsResponse Success
   * @throws ApiError
   */
  public brewingRecipesSettingsGet(): CancelablePromise<GetBrewingRecipesSettingsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/brewing-recipes-settings',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Save Brewing Recipes notifications
   * Subscribe or unsubscribe to a notification
   * @returns any Success
   * @throws ApiError
   */
  public brewingRecipesSettingsSaveNotification({
    requestBody,
  }: {
    requestBody?: SaveBrewingRecipesNotificationRequest,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/brewing-recipes-settings/notifications',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
